import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  subTitle: {
    textAlign: 'center',
    marginBottom: '25px',
  },
  content: {
    maxWidth: '470px',
    width: '100%',
    textAlign: 'center',
  },
  body: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '25px',
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    fontSize: '14px',
    marginBottom: '10px',
    gap: '10px'
  },
  label: {
    fontWeight: 500,
    width: '100px',
    textAlign: 'start',
  },
  rowValue: {
    width: '100px',
    textAlign: 'start',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    gap: '15px',
  },
  checkboxContainer: {
    marginTop: '25px',
  },
  checkboxLabel: {
    textAlign: 'left',
    fontSize: '16px',
    lineHeight: '1.5rem',
  },
}))
